import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserHelmetSafety } from '@fortawesome/pro-solid-svg-icons';

import type { BidSpecIconProps } from './types';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

const BidSpecIcon = ({
	size = '1x', colorOverride = '', className = ''
}: BidSpecIconProps) => (
	<FontAwesomeIcon
		icon={faUserHelmetSafety as IconProp}
		size={size}
		className={`${className} ${colorOverride && `text-${colorOverride}`}`}
	/>
);

export default BidSpecIcon;
